module.exports = __webpack_public_path__ + "static/Gotham-ExtraLight-16753d6ad90ca7b3f4df52b53aaa846c.woff2";